export default {
  'header.credits.request': 'Проект создан с благословения и по просьбе',
  'header.credits.person': 'Кьябдже Гарчена Триптрула Ринпоче',
  'header.title': '«37 практик Бодхисаттв»',

  'nav.book': '37 практик',
  'nav.bio': 'Биография',
  'nav.comments': 'Комментарии',
  'nav.archive': 'Архив',

  'book.controls.view': 'Смотреть',
  'book.controls.download': 'Скачать',

  'book.locale.ru': 'Русский',
  'book.locale.en': 'Английский',
  'book.locale.ua': 'Украинский',
  'book.locale.hw': 'Иврит',
  'book.locale.de': 'Немецкий',
  'book.locale.cn': 'Китайский',
  'book.locale.mg': 'Монгольский',
  'book.locale.ar': 'Арабский',
  'book.locale.tb': 'Тибетский',
  'book.locale.jp': 'Японский',
}



// WEBPACK FOOTER //
// ./src/intl/ru.js